import { queryKeys } from "../react-query/constants";
import { getLoginToken } from "../storage";
import { axiosInstance } from "../axios-Instance";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

async function getComment() {
  const data = await axiosInstance({
    url: "/comment",
    method: "GET",
  });

  return data?.data?.data;
}

async function createComment(formData) {
  const data = await axiosInstance({
    url: "/comment",
    method: "POST",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

async function updateComment(formData) {
  const data = await axiosInstance({
    url: `/comment/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

async function deleteComment(formData) {
  const data = await axiosInstance({
    url: `/comment/${formData["_id"]}`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

export function useComment() {
  const fallback = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.comment],
    queryFn: getComment,
  });
  return data;
}

export function useUpdateComment() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => updateComment(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.comment]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}

export function useAddComment() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => createComment(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.comment]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}

export function useDeleteComment() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => deleteComment(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.comment]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}
